import { render, staticRenderFns } from "./PrincipaisClientesExpo.vue?vue&type=template&id=7c0ed0ea"
import script from "./PrincipaisClientesExpo.vue?vue&type=script&lang=js"
export * from "./PrincipaisClientesExpo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports